import React from 'react';
import { vocabulary } from '../data/siteContent';

const VocabularySection: React.FC = () => {
  return (
    <section className="section-y">
      <div className="shell">
        <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-gutter">
          <div className="lg:col-span-7">
            <p className="kicker-action">{vocabulary.eyebrow}</p>
            <h2 className="display-lg mt-5 text-[2.25rem] sm:text-[2.85rem]">{vocabulary.title}</h2>
            <p className="prose-reading mt-6 max-w-reading">{vocabulary.body}</p>

            <dl className="mt-9 grid gap-px bg-ink/12 sm:grid-cols-3">
              {vocabulary.exports.map((item) => (
                <div key={item.label} className="bg-background p-5">
                  <dt className="font-display text-lg text-primary">{item.label}</dt>
                  <dd className="prose-note mt-1.5 text-[0.875rem]">{item.description}</dd>
                </div>
              ))}
            </dl>
          </div>

          <figure className="mx-auto w-full max-w-[17rem] lg:col-span-5 lg:max-w-[20rem]">
            <div className="plate bg-background p-2">
              <img
                src="/screenshots/iphone/05-vocabulary.png"
                width={1320}
                height={2868}
                alt="Lexeme vocabulary list showing saved Italian words with their lemmas, meanings and source sentences"
                className="block h-auto w-full"
                loading="lazy"
                decoding="async"
              />
            </div>
            <figcaption className="mt-4 flex items-baseline gap-3 border-t border-ink/15 pt-3">
              <span className="whitespace-nowrap font-display text-sm text-primary" aria-hidden="true">
                Pl. 05
              </span>
              <span className="prose-note text-[0.875rem]">
                Four saves from one evening, each still attached to its sentence.
              </span>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
};

export default VocabularySection;
